<template>
  <b-container>
    <div class="grid_container">
      <div class="grid">
        <figure
          v-for="(image, index) in images"
          :key="index"
          class="effect-lily"
        >
          <div>
            <img v-lazy="image.thumb" alt="img12" />
          </div>

          <figcaption @click="openGallery(index)">
            <div>
              <h2>
                <span> {{image.caption}} </span>
              </h2>
              <p>
                <a :href="image.src" download>
                  <b-button @click="click_download = true" class="figure_btn">
                    <b-icon icon="download" font-scale="1"></b-icon> Télécharger
                  </b-button>
                </a>
              </p>
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
    <LightBox ref="lightbox" :media="images" :showLightBox="false"></LightBox>
  </b-container>
</template>

<script>
require("vue-it-bigger/dist/vue-it-bigger.min.css");
import LightBox from "vue-it-bigger";
export default {
  components: { LightBox },
  props: ["images"],
  data() {
    return {
      click_download: false,
    };
  },
  methods: {
    openGallery(index) {
      if (!this.click_download) {
        this.$refs.lightbox.showImage(index);
      }
      this.click_download = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>